export default __webpack_public_path__ + "static/media/settings.ab753e5f.svg";